import React from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Div, Typography } from '@icecreamsocial/components';
import {
	usePagination,
	useStore,
} from '../../../../../../../../../../../utils/hooks';
import { queryKeys } from '../../../../../../../../../../../queries/influencers';
import {
	QuerySearchBar,
	Pagename,
	PopsicleLoader,
} from '../../../../../../../../../../presentational';

import { Table } from '../Table';
import { ExportButton } from '../ExportButton';
import { useInfluencerFilters } from '../FilterProvider';
import { useCampaign } from '../../../../../../providers/Campaign';

/**
 * Fetches and Displays data based on filters
 */
const DataView = () => {
	const { getInfluencers } = useStore();
	const { campaignId } = useParams();
	const { campaign } = useCampaign();
	const { state } = useInfluencerFilters();

	const { data } = campaign;
	const { eligibility, ...query } = state;
	const goalReached = eligibility ? eligibility === 'eligible' : null;

	/**
	 * update the influencer list on relevant query state changes or when data is stale
	 */
	const { data: influencers, isLoading, isRefetching, error } = useQuery(
		queryKeys.list({
			campaignId,
			goalReached,
			...query,
		}),
		() =>
			getInfluencers({
				campaignId,
				goalReached,
				...query,
			}),
		{ enabled: !!campaignId, refetchOnWindowFocus: false }
	);

	return (
		<>
			<Div display='flex' alignItems='center' justifyContent='space-between'>
				<Pagename>Influencer Performance</Pagename>
				<ExportButton disable={!influencers?.influencers.count} />
			</Div>
			<Div>
				<QuerySearchBar
					id='influencerSearch'
					name='search'
					placeholder='Find Influencers'
				/>
				{data ? (
					<Table
						campaign={data}
						influencers={influencers?.influencers}
						isLoading={isLoading || isRefetching}
						error={error}
					/>
				) : (
					<Div
						display='flex'
						padding='xlg'
						elMinHeight='300px'
						alignItems='center'
						justifyContent='center'
						flexDirection='column'
						backgroundColor='bodyInverse'
						borderRadius='default'
						borderColor='ambient'
						border='1px solid'
					>
						<PopsicleLoader />
						<Typography.P margin='none' textColor='ambientDark'>
							Just a moment...
						</Typography.P>
					</Div>
				)}
			</Div>
		</>
	);
};

DataView.displayName =
	'Campaigns.Campaign.Reports.InfluencerPerformance.DataView';
export default observer(DataView);
